import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Hammer from 'react-hammerjs';
import getScrollbarWidth from 'get-scrollbar-width';
import { TimelineMax } from 'gsap';

import CalcSlide from '../CalcSlide/CalcSlide';
import Results from '../Results/Results';
import Arrows from '../Arrows/Arrows';

import * as formulas from '../../services/formulas';

import './CalcSlider.scss';

const tl = new TimelineMax();

class CalcSlider extends Component {
  constructor(props) {
    super(props);
    this.lastDelta = 0;
    this.lastState = 0;
    this.distance = 0;
    this.flagRight = false;
    this.flagLeft = false;
    this.sliderConfig = {};
    this.resultParams = {
      transformX: 180
    };

    this.breachOfRight = 0;
    this.breachOfLeft = 0;

    this.lastPoint = 0;

    this.movingSlider = false;
  }

  componentDidMount() {
    window.onload = () => {
      this.$arrows = document.querySelectorAll('.arrows__item');
      this._setHolderParams();
    }
  }

  _setHolderParams = () => {
    const $holder = this.holder;
    const resultParams = this.result.getBoundingClientRect();
    const holderParams = $holder.getBoundingClientRect();
    const diffWindowAndHolderWidth = window.innerWidth - holderParams.right;

    this.distanceFromLeftToFirstInput = $holder
      .querySelector('.calc-slide__field-input')
      .getBoundingClientRect().x;

    this.sliderConfig.pointJoin = resultParams.x;
    this.sliderConfig.width = $holder.offsetWidth;
    this.sliderConfig.resOffsetLeft = resultParams.x;

    this.breachOfLeft = -1 * (holderParams.right - window.innerWidth + resultParams.width + (diffWindowAndHolderWidth > 0 ? diffWindowAndHolderWidth : 0));

    this.resultParams.visiblePartWidth = resultParams.width - Math.abs((resultParams.right - window.innerWidth));
    this.resultParams.additionalPartWidthForMove = this.resultParams.visiblePartWidth + holderParams.x + getScrollbarWidth();

    this.distanceMovingSliderByArrow = -1 * this.breachOfLeft;
  }

  _checkPointJoin = () => {
    const distance = this.sliderConfig.width + this.holder.getBoundingClientRect().x;

    if (distance <= this.sliderConfig.resOffsetLeft) {
      const resDistance = this.resultParams.transformX - (this.sliderConfig.resOffsetLeft - this.holder.getBoundingClientRect().right);
  
      this.result.style.transform = `translate3d(${resDistance}px, 0, 0)`;
      !this.result.classList.contains('cancelTransition') && this.result.classList.add('cancelTransition');
    } else {
      this.result.classList.remove('cancelTransition');
      this.result.style = '';
    }
  }

  panMove = (event) => {
    const delta = event.deltaX;
    const animateMoving = event.animate;
    const isInput = event.target && event && event.target.classList.contains('form__input');

    if (!isInput || animateMoving) {
      if (delta > 0 && this.flagRight === true) {
        return false;
      }

      if (delta < 0 && this.flagLeft === true) {
        return false;
      }

      if (this.distance > this.breachOfRight) {
        this.flagRight = true;
        this.flagLeft = false;
        
        this.distance = this.breachOfRight;
        this.holder.style.transform = `translate3d(${this.breachOfRight}px, 0, 0)`;
        
        return false;
      } else if (this.distance < this.breachOfLeft) {
        this.flagRight = false;
        this.flagLeft = true;
        
        this.distance = this.breachOfLeft;
        this.holder.style.transform = `translate3d(${this.breachOfLeft}px, 0, 0)`;
        
        return false;
      } else {
        this.flagRight = false;
        this.flagLeft = false;

        this.lastDelta = this.lastState + delta;

        if (this.lastDelta < this.breachOfLeft) {
          this.lastDelta = this.breachOfLeft;
        } else if (this.lastDelta > this.breachOfRight) {
          this.lastDelta = this.breachOfRight;
        }

        this.distance = this.lastDelta;
        this.holder.style.transform = `translate3d(${this.distance}px, 0, 0)`;

        this._checkPointJoin();
      }
    }
  }

  saveDistance = (event) => {
    const deltaX = event._deltaX;

    if (!this.$arrows) {
      return false;
    }

    if (this.distance > this.breachOfRight) {
      this.holder.style.transform = `translate3d(${this.breachOfRight}px, 0, 0)`;
      return false;
    }

    this.lastState = deltaX ? (this.lastState + deltaX) : this.distance;

    this.lastState = (this.lastState > this.breachOfRight) ? this.breachOfRight : 
                     (this.lastState < this.breachOfLeft) ? this.breachOfLeft : this.lastState;

    if (this.lastState < this.breachOfRight && this.lastState > this.breachOfLeft) {
      Array.prototype.forEach.call(this.$arrows, ($item) => {
        $item.classList.remove('disabled');
      });
    } else if (this.lastState <= this.breachOfLeft) {
      this.$arrows[0].classList.remove('disabled');
      this.$arrows[1].classList.add('disabled');
    } else if (this.lastState >= this.breachOfRight) {
      this.$arrows[0].classList.add('disabled');
      this.$arrows[1].classList.remove('disabled');
    }

    this.holder.style.transform = `translate3d(${this.distance}px, 0, 0)`;
  }

  onMoveSlider = (event) => {
    const $arrow = event.target;
    const direction = event.direction || parseInt($arrow.dataset.direction, 10);
    const distanceParams = {
      diff: 0
    };

    if ($arrow && $arrow.classList.contains('disabled')) {
      return false;
    }

    if (this.movingSlider === true) {
      return false;
    }

    this.movingSlider = true;
  
    tl
      .to(distanceParams, 0.5, { diff: event.distanceToInput || this.distanceMovingSliderByArrow });

    tl
      .eventCallback("onUpdate", (data) => {
        const distance = distanceParams.diff * direction;

        this.panMove({
          deltaX: distance,
          animate: true
        });
      })
      .eventCallback("onComplete", () => {
        const distance = distanceParams.diff * direction;

        this.movingSlider = false;
        this.saveDistance({
          _deltaX: distance
        });
      });
  }
  
  movingAfterFocus = ($input) => {
    const AVERAGE_DISSTANCE_BETWEEN_SLIDES = this.result.getBoundingClientRect().width;
    const rectInet = $input.getBoundingClientRect();

    if (window.innerWidth < rectInet.right + AVERAGE_DISSTANCE_BETWEEN_SLIDES) {
      this.onMoveSlider({
        distanceToInput: AVERAGE_DISSTANCE_BETWEEN_SLIDES,
        direction: -1
      });
    } else if (rectInet.left < 0) {
      this.onMoveSlider({
        distanceToInput: Math.abs(rectInet.left) + this.distanceFromLeftToFirstInput,
        direction: 1
      });
    }
  }

  checkEndInput = (event) => {
    const $input = event.target;
    const $btn = document.getElementById('btn-moving');

    if ($input.classList.contains('js-trigger-to-bottom')) {
      $input.blur();
      $btn.click();
    }
  }

  render() {
    const { langs } = window;
    const { currentLang } = this.props;

    return (
      <div className="calc">
        <Arrows handleMoveSlider={ this.onMoveSlider }/>
        <div className="calc__wrap">
          <form className="calc__form">
            <Hammer onPan={this.panMove} onPanEnd={this.saveDistance}>
              <div className="calc__holder">
                <div className="calc__inner" ref={(holder) => {this.holder = holder}}>
                  <CalcSlide 
                    title={ langs.acquiredUsers }
                    fields={[
                      {
                        name: "UA",
                        fullName: "(User Acquisition)",
                        suffix: ''
                      }
                    ]}
                    currentLang={ currentLang }
                    modificators={['small']}
                    movingAfterFocus={this.movingAfterFocus}
                  />

                  <CalcSlide 
                    title={ langs.costOfSoldGood }
                    fields={[
                      {
                        name: "CPC",
                        fullName: "(Cost per click)",
                        suffix: ` ${ langs.currencySymbol }`,
                        operation: '/'
                      },
                      {
                        name: "CR1",
                        fullName: "(Conversion rate)",
                        suffix: '%',
                        operation: '/'
                      },
                      {
                        name: "CR2",
                        fullName: "(Conversion rate)",
                        suffix: '%'
                      }
                    ]}
                    currentLang={ currentLang }                    
                    modificators={['large', 'max-zIndex']}
                    symbol="minus"
                    slideValue={{
                      isNegative: true,
                      value: formulas.CPPU,
                      suffix: langs.currencySymbol
                    }}
                    movingAfterFocus={this.movingAfterFocus}
                  />

                  <CalcSlide 
                    title={ langs.revenuePerUser }
                    fields={[
                      {
                        name: "AvP",
                        fullName: "(Average price)",
                        suffix: ` ${ langs.currencySymbol }`,
                        startSymbol: '(',
                        operation: '–'
                      },
                      {
                        name: "COGS",
                        fullName: "(Cost of Goods Sold)",
                        suffix: ` ${ langs.currencySymbol }`,
                        endSymbol: ')',
                        operation: 'x'
                      },
                      {
                        name: "Ret",
                        suffix: '',
                        fullName: "(Retention)"
                      }
                    ]}
                    currentLang={ currentLang }                    
                    modificators={['medium', 'bottom-shadow', 'right-border', 'min-right-padd', 'half-border-symbol']}
                    symbol="plus"
                    slideValue={{
                      value: formulas.ARPPU,
                      suffix: langs.currency
                    }}
                    printSlideValue={true}
                    movingAfterFocus={this.movingAfterFocus}
                  />
                </div>
              </div>
            </Hammer>
            <input 
              type="text"
              className="calc-slide__field-input calc-slide__field-input_hidden js-trigger-to-bottom"
              onFocus={this.checkEndInput}
            />
          </form>
        </div>
        <div className="calc__results" ref={(result) => { this.result = result }}>
          <Results />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { language } = state;
  return {
    currentLang: language.current,
    initialValues: {
      UA: 0,
      CPC: 0,
      CR1: 0,
      CR2: 0,
      AvP: 0,
      COGS: 0,
      Ret: 0
    }
  }
}

CalcSlider = reduxForm({
  form: 'profit'
})(CalcSlider);

export default connect(mapStateToProps)(CalcSlider);



// WEBPACK FOOTER //
// ./src/components/CalcSlider/CalcSlider.js